<template>
  <modal :show.sync="modalOpen" bodyClasses="pt-0 pb-0">
    <h4 slot="header" class="modal-title" id="modal-title-default">
      Edit {{profile && profile.user ? profile.user.Name : ''}}
    </h4>

    <div class="row">
      <div class="col-12">
        <base-input
          alternative=""
          label="Initial Handicap"
          placeholder="Initial Handicap"
          input-classes="form-control-alternative"
          v-model="model.handicap"
          :error="errors.handicap"
          type="number"
        />
      </div>
      <div class="col-12">
        <label :class="['form-control-label', {'text-danger': errors.paidInFull !== ''}]">
          Payment Type
        </label><br />
        <PaymentToggle
          v-model="model.paidInFull"
        />
      </div>
      <div class="col-12">
        <label :class="['form-control-label']">
          Toonie Pot
        </label><br />
        <base-switch v-model="model.tooniePot"></base-switch>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="primary"
        @click="saveProfile"
      >
        Save Player
      </base-button>
      <base-button
        type="link"
        class="ml-auto"
        @click="$emit('close')"
      >
        Cancel
      </base-button>
    </template>
  </modal>
</template>
<script>
import PaymentToggle from '@/components/PaymentToggle.vue';

export default {
  name: 'EditPlayerModal',
  components: {
    PaymentToggle,
  },
  props: {
    player: [String, Number],
    open: Boolean,
  },
  data() {
    return {
      profile: null,
      model: {
        handicap: '',
        paidInFull: '',
        tooniePot: false,
      },
      errors: {
        handicap: '',
        paidInFull: '',
        tooniePot: '',
      },
    };
  },
  computed: {
    modalOpen: {
      get() {
        return this.open;
      },
      set() {
        this.$emit('close');
      },
    },
  },
  watch: {
    player() {
      if (this.player !== null) {
        this.getPlayerProfile();
      }
    },
    profile() {
      if (this.profile !== null) {
        this.model.handicap = this.profile.handicap;
        this.model.tooniePot = this.profile.tooniePot;
        if (this.profile.paidInFull) {
          this.model.paidInFull = 'full';
        } else if (this.profile.paidDeposit) {
          this.model.paidInFull = 'deposit';
        } else {
          this.model.paidInFull = 'week';
        }
      }
    },
  },
  methods: {
    checkForErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });

      if (this.model.handicap === null || this.model.handicap === '') {
        this.errors.handicap = 'This field is required';
      }
      if (this.model.paidInFull === '') {
        this.errors.paidInFull = 'Required';
      }
    },
    saveProfile() {
      this.checkForErrors();
      let isOk = true;

      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (!isOk) {
        return;
      }

      const updatedProfile = {
        handicap: this.model.handicap,
        paidInFull: this.model.paidInFull === 'full',
        paidDeposit: this.model.paidInFull === 'deposit',
        tooniePot: this.model.tooniePot,
      };

      this.axios
        .put(`/profiles/${this.player}`, updatedProfile, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.$emit('close');
        });
    },
    getPlayerProfile() {
      this.axios
        .get(`/profiles/${this.player}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.profile = response.data;
        });
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
